import React from "react";
import { FormGroup, FormControl, ControlLabel, HelpBlock } from "react-bootstrap";

var DatePicker = require("react-bootstrap-date-picker");

function getValidationState(validation) {
  if (validation === null) {
    return null;
  }

  if (validation.valid) {
    return "success";
  } else {
    return "error";
  }
}

function FieldGroup({ id, label, help, validationState, validationMessage, ...props }) {
  return (
    <FormGroup controlId={id} validationState={ getValidationState(validationState) }>
      <ControlLabel>{ label }</ControlLabel>
      { props.type === "date" ? <DatePicker {...props} />
        : <FormControl {...props} />}{" "}
      { help &&
        <HelpBlock>
          { help }
        </HelpBlock>
      }
      { validationMessage && validationState && !validationState.valid &&
        <HelpBlock>
          { validationMessage }
        </HelpBlock>
      }
    </FormGroup>
  )
}

export default FieldGroup;



// WEBPACK FOOTER //
// ./src/components/FieldGroup/index.js